import { List, Datagrid, NumberField, DateField, FunctionField, TextInput } from "react-admin";
import { StatusChip } from "../../components/StatusChip";
import { CopyableId } from "../../components/CopyableId";

const filters = [
  <TextInput key="roundId" source="roundId" label="Round ID" alwaysOn />,
];

export const RoundList = () => (
  <List filters={filters} sort={{ field: "startedAt", order: "DESC" }} perPage={25}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <FunctionField label="Round ID" render={(r: { roundId?: string }) => <CopyableId value={r?.roundId} />} />
      <FunctionField label="State" render={(r: { state?: string }) => <StatusChip value={r?.state} />} />
      <NumberField source="crashPoint" label="Crash Point" options={{ minimumFractionDigits: 2 }} />
      <DateField source="initializedAt" label="Initialized" showTime />
      <DateField source="startedAt" label="Started" showTime />
      <DateField source="crashedAt" label="Crashed" showTime />
    </Datagrid>
  </List>
);
